module.exports = __webpack_public_path__ + "static/media/ifca-logo-black.e2b761d0.svg";